export const isAdvancedPushNotificationUser = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_ADVANCED_PUSH_NOTIFICATION' &&
      !!permission.status,
  );
};
